/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type PdpRespShippingReturns_item = {| |};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespShippingReturns_item",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailPayments_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailReturnPolicy_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDepositPaymentDetail_item",
      "args": null
    }
  ],
  "type": "Item"
};

module.exports = fragment;
